import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useCandidateLanguage } from '../../i18n/candidate';

export default function ScreeningTimeUp() {
  const navigate = useNavigate();
  const { screeningId } = useParams();
  const t = useCandidateLanguage({ screeningId });

  const handleOk = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="min-h-screen bg-white-smoke px-4 py-6 sm:py-8 flex flex-col">
      <div className="mx-auto max-w-4xl w-full flex-1 flex flex-col">
        <header className="flex items-center justify-between gap-3">
          <div className="flex flex-col min-w-0">
            <p className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              {t('Powered by')}
            </p>
            <div className="mt-0.5 flex items-center gap-1.5">
              <img
                src="/logo.svg"
                alt="TalentCrux"
                className="h-9 w-9 sm:h-12 sm:w-12 md:h-14 md:w-14 object-contain flex-shrink-0"
              />
              <span className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 truncate">
                TalentCrux
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="hidden sm:inline-flex items-center rounded-full bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-700 border border-rose-100">
              {t("Time's up")}
            </span>
          </div>
        </header>

        <main className="flex-1 flex items-center">
          <div className="w-full">
          <div className="rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden">
            <div className="bg-lavender-purple-50 px-4 py-3 sm:px-6 sm:py-4 flex items-center justify-between gap-3">
              <div className="flex items-center gap-2">
                <div className="flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-white text-lavender-purple shadow-sm">
                  <ExclamationTriangleIcon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900 sm:text-base">
                    {t('Your screening time is up')}
                  </p>
                  {/* <p className="hidden sm:block text-xs text-gray-600">
                    The allotted time window to complete this screening has ended.
                  </p> */}
                </div>
              </div>
              <span className="inline-flex items-center rounded-full bg-white/70 px-3 py-1 text-[11px] font-medium text-lavender-purple border border-lavender-purple-100">
                {t('Session closed')}
              </span>
            </div>

            <div className="px-4 py-5 sm:px-8 sm:py-8">
              <div className="max-w-xl">
                <p className="text-sm text-gray-700 sm:text-base">
                  {t('Your screening time has ended. All responses have been saved.')}
                </p>
                <p className="mt-3 text-sm text-gray-600">
                  {t("We'll review your responses and follow up if there's a match.")}
                </p>

                {/* <div className="mt-5 sm:mt-6">
                  <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                    What you can do next
                  </h2>
                  <ul className="mt-2 space-y-1.5 text-sm text-gray-600">
                    <li className="flex gap-2">
                      <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-electric-blue" />
                      <span>Keep an eye on your email for updates from the recruiter.</span>
                    </li>
                    <li className="flex gap-2">
                      <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-electric-blue" />
                      <span>Close this window once you&apos;re done reviewing this message.</span>
                    </li>
                  </ul>
                </div> */}

                <div className="mt-6 sm:mt-8">
                  <p className="text-xs text-gray-400">
                    {t('Have questions? contact')} <a className="text-electric-blue hover:text-electric-blue-600 hover:underline" href="mailto:support@talentcrux.ai">support@talentcrux.ai</a>.
                  </p>
                </div>
              </div>

              {/* <div className="mt-4 sm:mt-6 flex justify-end">
                <button
                  type="button"
                  onClick={handleOk}
                  className="inline-flex items-center justify-center rounded-lg bg-electric-blue px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-electric-blue-600 focus:outline-none focus:ring-2 focus:ring-electric-blue focus:ring-offset-2 focus:ring-offset-white transition-colors whitespace-nowrap"
                >
                  Back to homepage
                </button>
              </div> */}
            </div>
          </div>
          </div>
        </main>
      </div>
    </div>
  );
}

